import { AgGrid } from "@jsq/ds/core";

export const sideBarDef: AgGrid.SideBarDef = {
  position: "right",
  toolPanels: [
    {
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressColumnFilter: false,
        suppressColumnSelectAll: false,
        suppressColumnExpandAll: true,
      },
    },
  ],
};

export const getRowId = (
  params: AgGrid.GetRowIdParams | Partial<AgGrid.GetRowIdParams>,
): string => {
  const data: unknown = params.data;
  if (typeof data !== "object" || data === null) return "";
  if ("billingCaseId" in data && typeof data.billingCaseId === "number") {
    return String(data.billingCaseId);
  }
  return "";
};

export const updateGridDataSource = (
  gridApi: AgGrid.GridApi | undefined,
  dataSource: AgGrid.IServerSideDatasource | null,
): void => {
  if (!gridApi || !dataSource) return;
  gridApi.setGridOption("serverSideDatasource", dataSource);
  gridApi.refreshServerSide({ purge: true });
};
